import {Link} from "react-router-dom";
import {Popconfirm, Switch} from "antd";

const MarkerMobileColumns = (t, onStatusChange, updatingStatusIds = []) => [
    {
        title: t("pages.markerMobile.listColumns.id"),
        dataIndex: "id",
        width: 80,
    },
    {
        title: (
            <span style={{textDecoration: "underline"}}>
                {t("pages.markerMobile.listColumns.licenseDeviceId")}
            </span>
        ),
        dataIndex: "license_device_id",
        render: (value, record) => (
            <Link
                className="marker-mobile-list__license-link"
                to={`/devices/marker-mobile/detail/${record.id}`}
            >
                {value}
            </Link>
        ),
    },
    {
        title: t("pages.markerMobile.listColumns.companyInn"),
        dataIndex: "company_inn",
    },
    {
        title: t("pages.markerMobile.listColumns.company"),
        dataIndex: "company_name",
    },
    {
        title: t("pages.markerMobile.listColumns.deviceSerialNumber"),
        dataIndex: "device_serial_number",
    },
    {
        title: t("pages.markerMobile.listColumns.status"),
        dataIndex: "is_active",
        filters: [
            {text: t("common.active"), value: true},
            {text: t("common.inactive"), value: false},
        ],
        filterMultiple: false,
        render: (isActive, record) => {
            const nextStatus = !Boolean(isActive);

            return (
                <Popconfirm
                    title={t("pages.markerMobile.statusConfirm.title")}
                    description={t("pages.markerMobile.statusConfirm.description", {
                        status: nextStatus ? t("common.active") : t("common.inactive"),
                    })}
                    okText={t("pages.markerMobile.statusConfirm.confirm")}
                    cancelText={t("pages.markerMobile.statusConfirm.cancel")}
                    onConfirm={() => onStatusChange(record, nextStatus)}
                    disabled={updatingStatusIds.includes(record.id)}
                >
                    <Switch
                        checked={Boolean(isActive)}
                        checkedChildren={t("common.active")}
                        unCheckedChildren={t("common.inactive")}
                        loading={updatingStatusIds.includes(record.id)}
                    />
                </Popconfirm>
            );
        },
    },
    {
        title: t("pages.markerMobile.listColumns.createdDate"),
        dataIndex: "created_date",
        orderIndex: "created_date",
        sorter: true,
    },
    {
        title: t("pages.markerMobile.listColumns.updatedDate"),
        dataIndex: "updated_date",
    },
];

export default MarkerMobileColumns;
